import { useCallback } from 'react'
import SegmentedOption from 'LuxKit/SegmentedOptions/SegmentedOption'
import SegmentedOptionsGroup from 'LuxKit/SegmentedOptions/SegmentedOptionsGroup'
import useOfferPageDispatch from 'hooks/OfferPage/useOfferPageDispatch'
import withOfferPageState from 'contexts/OfferPage/withOfferPageState'
import type { OfferPageMultiRoomMode } from 'contexts/OfferPage/offerPageStateReducer'
import { OfferPageActions } from 'contexts/OfferPage/offerPageStateReducer'
import { useIntl } from 'react-intl'

interface Props {
  inputsName: string
  mode: OfferPageMultiRoomMode
}

function MultiRoomModeToggle({ inputsName, mode }: Props) {
  const intl = useIntl()
  const dispatch = useOfferPageDispatch()

  const onModeChange = useCallback((mode: OfferPageMultiRoomMode) => {
    dispatch({ type: OfferPageActions.toggleMultiRoomMode, multiRoomMode: mode })
  }, [dispatch])

  return (
    <SegmentedOptionsGroup onValueChange={onModeChange} inputsName={inputsName}>
      <SegmentedOption
        title={intl.formatMessage({
          id: 'FxysofOuIycLSsxYWYcJ',
          defaultMessage: 'Individually',
        })}
        value="individual"
        checked={mode === 'individual'}
      />
      <SegmentedOption
        title={intl.formatMessage({
          id: 'llH5PsAKJuIK1E6kAAox',
          defaultMessage: 'Same for all rooms',
        })}
        value="same-room"
        checked={mode === 'same-room'}
      />
    </SegmentedOptionsGroup>
  )
}

export default withOfferPageState((state) => {
  return {
    mode: state.multiRoomMode,
  }
}, MultiRoomModeToggle)
